import { HOME_BOOTSTRAP_URL, NOWID_PROXY_URL } from '../config';
import { fetchHeaderMenuCached } from './headerApiService';
import language from '../utils/LanguageSettings';
import { normalizeSiteLang } from './userIdentity';

export const loadHomeBootstrap = async (): Promise<Record<string, unknown>> => {
  const initialLang = language;
  let bootstrapData: Record<string, unknown> = {
    currentLang: initialLang,
  };

  const bootstrapUrl = HOME_BOOTSTRAP_URL || `${NOWID_PROXY_URL}?action=home-bootstrap`;

  if (bootstrapUrl) {
    try {
      const url = `${bootstrapUrl}${bootstrapUrl.includes('?') ? '&' : '?'}lang=${initialLang}`;
      const response = await fetch(url, { credentials: 'include' });
      if (response.ok) {
        const data = await response.json();
        if (data && typeof data === 'object') {
          bootstrapData = {
            ...bootstrapData,
            ...data,
          };
        }
      }
    } catch (error) {
      // Non-blocking: homepage can still render without bootstrap data.
      console.warn('Home bootstrap fetch failed:', error);
    }
  }

  const resolvedLang = normalizeSiteLang((bootstrapData.currentLang as string) || initialLang);

  try {
    const menus = await fetchHeaderMenuCached(resolvedLang);
    bootstrapData = {
      ...bootstrapData,
      currentLang: resolvedLang,
      menus,
    };
  } catch (error) {
    // Non-blocking: header can still render with empty menus.
    console.warn('Header menu fetch failed:', error);
  }

  return bootstrapData;
};
